import { fitToSize, sizeOptionsOrDefault } from './utils';
import { Rectangle } from './Rectangle';
const defaultOptions = {
    arcRadiusXRatio: 0.17,
    arcRadiusYRatio: 0.3,
};
/**
 * A visual element that renders a delay symbol with curved right edge.
 * Extends Rectangle and provides functionality for creating delay/wait process shapes.
 */
export class Delay extends Rectangle {
    /**
     * Creates a new Delay instance.
     * @param options Configuration options for the delay shape
     */
    constructor(options) {
        super({ ...defaultOptions, ...options });
    }
    /** @hidden */
    _drawPath() {
        const drawingElement = this.drawingElement;
        const { width, height } = sizeOptionsOrDefault(this.options);
        const strokeWidth = this.options.stroke.width || 0;
        const { arcRadiusXRatio, arcRadiusYRatio, cornerRadius } = this.options;
        const arcRadiusX = width * arcRadiusXRatio;
        const arcRadiusY = height * arcRadiusYRatio;
        drawingElement
            .moveTo([0, cornerRadius])
            .arcTo([cornerRadius, 0], cornerRadius, cornerRadius, true, false)
            .lineTo([width - arcRadiusX, 0])
            .arcTo([width - arcRadiusX, height], arcRadiusX, arcRadiusY, false, false)
            .lineTo([cornerRadius, height])
            .arcTo([0, height - cornerRadius], cornerRadius, cornerRadius, true, false)
            .close();
        fitToSize(this.drawingElement, width, height, strokeWidth);
    }
}
